"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Interactive = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Interactive = function Interactive() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M39.89,12.55c0.17-2.18,0.99-4.33,2.5-6.14C46.24,1.8,53.1,1.18,57.72,5.03s5.23,10.71,1.38,15.33\r c-1.72,2.07-4.05,3.33-6.51,3.75"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M25.95,62.5c0,0,7.46-6.05,15.22-9.57c0,0,8.36-4.53,9.47-5.54c1.11-1.01,2.99-2.42,1.85-6.2\r c-1.14-3.78-6.89-0.45-6.89-0.45l-7.76,3.43l13-25.6c0,0,1.61-2.92-0.91-4.74c-2.09-1.5-5.14-0.5-6.05,1.71\r c-0.91,2.22-8.77,16.02-8.77,16.02"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M27.05,29.85l4.23-7.66c0,0,2.37-3.26,4.94-2.02c3.12,1.51,2.72,4.43,2.72,4.43"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M18.99,28.44l4.23-7.66c0,0,2.37-3.26,4.94-2.02c3.12,1.51,2.79,3.97,2.79,3.97"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M22.67,21.85c0,0-0.05-2.59-3.18-4.1c-2.57-1.24-4.94,2.02-4.94,2.02l-4.33,7.66c0,0-2.92,4.84-3.63,8.87\r S3.37,50.61,3.37,50.61"
        })]
      })]
    })
  });
};
exports.Interactive = Interactive;